import WebViewer from '@pdftron/pdfjs-express-viewer';
import { useEffect, useRef } from 'react';

export default function PDFViewer (props) {
    const viewer = useRef(null);
  
    useEffect(() => {
      WebViewer(
        {
          path: '/webviewer/lib',
          initialDoc: props.url,
          licenseKey :'4FZLP4gGveTTEUiC7zqv'
        },
        viewer.current,
      ).then((instance) => {
          // now you can access APIs through the WebViewer instance
          const { Core } = instance;
  
          // adding an event listener for when a document is loaded
          Core.documentViewer.addEventListener('documentLoaded', () => {
            console.log('document loaded');
          });
  
          // adding an event listener for when the page number has changed
          Core.documentViewer.addEventListener('pageNumberUpdated', (pageNumber) => {
            console.log(`Page number is: ${pageNumber}`);
          });
        });
      }, []);
  
    return (
      <div style={{height: '100%'}}  >
        {/* <div className="header">React sample</div> */}
        <div style={{height: '100%'}} ref={viewer}></div>
      </div>
    );
  };